import { useTranslation } from "react-i18next";
import { DocumentCard } from "./components/DocumentCard";
import { getAllDocuments } from "./documents/documentMetadata";

export const TermsAndPoliciesPage = () => {
	const { t } = useTranslation();
	const documents = getAllDocuments();

	return (
		<div className="space-y-4">
			<div>
				<h1 className="text-lg font-bold text-gray-900">
					{t("Terms and Policies")}
				</h1>
				<p className="mt-2 text-sm text-gray-600">
					{t(
						"Here you can view our various policy documents and their update history.",
					)}
				</p>
			</div>

			<div className="overflow-hidden rounded-lg border border-gray-200 bg-white">
				<div className="divide-y divide-gray-200">
					{documents.map((document, index) => (
						<div key={document.id} className={index === 0 ? "px-6" : "px-6"}>
							<DocumentCard document={document} />
						</div>
					))}
				</div>
			</div>
		</div>
	);
};
